export function customChartTooltip(context: any): void {
  let tooltipEl = document.getElementById('chartjs-tooltip-custom');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip-custom';
    tooltipEl.innerHTML = '<div class="tooltip-caret"></div><table></table>';
    document.body.appendChild(tooltipEl);
  }

  const tooltipModel = context.tooltip;
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = '0';

    return;
  }

  if (tooltipModel.body) {
    const titleLines = tooltipModel.title || [];
    let innerHtml = '<thead>';

    titleLines.forEach((title: string) => {
      innerHtml += `<tr><th style="text-align: left;">${title}</th></tr>`;
    });

    innerHtml += '</thead><tbody>';

    if (tooltipModel.body[0].lines.length > 1) {
      tooltipModel.body[0].lines.forEach((line: string) => {
        innerHtml += `<tr><td>${line}</td></tr>`;
      });
    } else {
      innerHtml += splitIntoLines(tooltipModel.body[0].lines[0]);
    }

    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');

    if (tableRoot) {
      tableRoot.innerHTML = innerHtml;
    }
  }

  const tooltipData = tooltipModel.dataPoints[0];
  const element = context.chart.getDatasetMeta(tooltipData.datasetIndex).data[tooltipData.dataIndex];
  const elementPosition = element.tooltipPosition();
  const barHeight = element.height;
  const tooltipWidth = tooltipEl.clientWidth;
  const heightAdjustment = barHeight ? (barHeight / 2) - 20 : -27;
  const position = context.chart.canvas.getBoundingClientRect();
  const x = context.tooltip.caretX;
  const width = context.chart.width;
  const isLeftHalf = x < width / 2;

  tooltipEl.style.width = 'unset';
  tooltipEl.style.opacity = '1';
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.left = isLeftHalf
    ? position.left + window.pageXOffset + tooltipModel.caretX + 35 + 'px'
    : Math.max(position.left + window.pageXOffset + tooltipModel.caretX - tooltipWidth - 35, 0) + 'px';
  tooltipEl.style.top = position.top + window.pageYOffset + elementPosition.y + heightAdjustment + 'px';
  tooltipEl.style.fontFamily = 'Poppins, sans-serif';
  tooltipEl.style.fontSize = '14px';
  tooltipEl.style.fontWeight = '400';
  tooltipEl.style.color = '#fff';
  tooltipEl.style.backgroundColor = '#40bfea';
  tooltipEl.style.padding = 24 + 'px';
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.borderColor = '#40bfea';
  tooltipEl.style.borderRadius = 8 + 'px';
  tooltipEl.style.boxShadow = '0px 0px 20px 5px rgba(0, 0, 0, 0.2)';
  tooltipEl.style.zIndex = '9999';

  const datapointX = element.x;

  if (tooltipEl.style.left === '0px' && tooltipEl.clientWidth > datapointX) {
    tooltipEl.style.width = `${datapointX - 10}px`;
    tooltipEl.style.left = datapointX - position.left + 'px';
  }

  const caretEl = tooltipEl.querySelector('.tooltip-caret') as HTMLElement;
  caretEl.style.position = 'absolute';
  caretEl.style.borderTop = '7px solid transparent';
  caretEl.style.borderBottom = '7px solid transparent';
  caretEl.style.borderRight = '14px solid #40bfea';
  caretEl.style.left = isLeftHalf ? '-13px' : '100%';
  caretEl.style.top = '20px';
  caretEl.style.transform = isLeftHalf ? '' : 'rotate(180deg)';
  caretEl.style.zIndex = '9999';
}

function splitIntoLines(text: string): string {
  if (text.includes('<br>')) {
    const parts = text.split('<br>');
    const lines: string[] = [];

    parts.forEach(part => {
      lines.push(part);
    });

    return lines.join('<br>');
  }

  const lines = [];
  const words = text.split(' ');
  let currentLine = '';

  words.forEach(word => {
    if (currentLine.length + word.length < 40) {
      if (currentLine.length > 0) {
        currentLine += ' ';
      }

      currentLine += word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  lines.push(currentLine);
  let htmlText = '';
  lines.forEach(line => {
    htmlText += line + '<br>';
  });

  htmlText = htmlText.replace(/<br>$/, '');

  return htmlText;
}
